export const FETCH_SIGNUPCOUNTRY_ACTION = "FETCH_SIGNUPCOUNTRY_ACTION";
export const FETCH_SIGNUPCOUNTRY_FAIL_ACTION = FETCH_SIGNUPCOUNTRY_ACTION + "_ERROR";
export const FETCH_SIGNUPCOUNTRY_SUCCESS_ACTION = FETCH_SIGNUPCOUNTRY_ACTION + "_SUCCESS";

export const ADD_SIGNUP_ACTION = "ADD_SIGNUP_ACTION";
export const ADD_SIGNUP_FAIL_ACTION = ADD_SIGNUP_ACTION + "_ERROR";
export const ADD_SIGNUP_SUCCESS_ACTION = ADD_SIGNUP_ACTION + "_SUCCESS";

export function fetchCountry() {
  return {
    type: FETCH_SIGNUPCOUNTRY_ACTION,
  };
}
export function signup(cred) {
  return {
    type: ADD_SIGNUP_ACTION,
    cred: cred,
  };
}
